export default __webpack_public_path__ + "static/expo3-b881920ae85309b487a16aa6f17211d8.jpg";